import { request } from '../../helpers/api/request';
import { FeedBodyWithId, FeedContract } from '../../types/Endpoints/feeds';

export const updateFeed = async (requestBody: FeedBodyWithId) => {
    const { data } = await request<FeedContract>({
        method: 'PUT',
        url: `admin/feeds/${requestBody.id}`,
        data: requestBody,
    });

    return data;
};
